import { Box } from '@chakra-ui/react';

import { NoEntries } from '@/components/NoEntries/NoEntries';
import { SuperOfferCard } from '@/components/SuperOffers/SuperOfferCard';

import { Promotion } from '@/models/api/SuperOffer';

type SuperOffersGridProps = {
    promotions: Promotion[];
};

export const SuperOffersGrid = ({ promotions }: SuperOffersGridProps) => {
    return (
        <Box mt={8}>
            {promotions?.length ? (
                promotions.map((item) => {
                    return <SuperOfferCard promotion={item} key={item.product.code} />;
                })
            ) : (
                <NoEntries message="page.super-offers.no-entries" />
            )}
        </Box>
    );
};
